/**
 * Countries that trigger the simplified registration flow (shortForm):
 * only name, phone, email and password — no nationality, document or
 * birthdate. Spain has always been on this list; SQD-403 added Mexico,
 * USA, Canada, Costa Rica, Colombia, Guatemala, United Kingdom, Chile,
 * Peru, Ecuador, Switzerland and Argentina.
 *
 * Single source of truth: `SHORT_FORM_DDIS` and `SHORT_FORM_NATIONALITIES`
 * are derived from this list to avoid divergence when a country is added
 * or removed.
 *
 * Note: matching by ddi alone catches every country sharing the same
 * callingCode. Listing USA and CAN explicitly (both `"1"`) is harmless
 * for the includes() check but documents the intent — any other `+1`
 * territory (Bahamas, Anguilla, etc.) returned by the /country API will
 * also fall into the shortForm flow.
 */
const SHORT_FORM_COUNTRIES = [
    { alpha3: "ESP", ddi: "34" },
    { alpha3: "MEX", ddi: "52" },
    { alpha3: "USA", ddi: "1" },
    { alpha3: "CAN", ddi: "1" },
    { alpha3: "CRI", ddi: "506" },
    { alpha3: "COL", ddi: "57" },
    { alpha3: "GTM", ddi: "502" },
    { alpha3: "GBR", ddi: "44" },
    { alpha3: "CHL", ddi: "56" },
    { alpha3: "PER", ddi: "51" },
    { alpha3: "ECU", ddi: "593" },
    { alpha3: "CHE", ddi: "41" },
    { alpha3: "ARG", ddi: "54" },
];

/* User Constants */
export const userConstants = {
    FILTERS:
        "id,type,email,name,lastname,document,verified,fbUserId,ddi,phone,birthdate,picture,pictures,newsletter,city,state,street,district,zip,number,complement",

    /* Required Info */
    REQUIRED: [
        "name",
        "ddi",
        "phone",
        "nationality",
        "document",
        "birthdate",
        "email",
    ],
    SIMPLE_FORM_REQUIRED: [
        "name",
        "ddi",
        "phone",
        "email",
    ],
    REQUIRED_MSG:
        "Antes de continuar, é necessário preencher algumas informações obrigatórias para o seu perfil.",

    SHORT_FORM_COUNTRIES,
    SHORT_FORM_NATIONALITIES: SHORT_FORM_COUNTRIES.map((c) => c.alpha3),
    SHORT_FORM_DDIS: Array.from(
        new Set(SHORT_FORM_COUNTRIES.map((c) => c.ddi))
    ),

    /* Actions */
    SET_DATA: "USER:SET_DATA",
    SET_INCOMPLETE: "USER:SET_INCOMPLETE",
};
